<template>
  <section class="about-cover">
    <div class="about-cover__logo-space">
      <WhiteLogo class="about-cover__logo" />
      <div class="about-cover__description">
        <span>gifteeは、ギフト選びからお渡しまで、</span>
        <span>オンラインで完結できるカジュアルギフトサービスです</span>
      </div>
      <button class="about-cover-start-button" @click="onClickStartButton">
        <span class="about-cover-start-button__text">さっそくはじめる</span>
        <ArrowForward class="about-cover-start-button__icon" />
      </button>
    </div>
  </section>
</template>
<script>
import WhiteLogo from '../../../atoms/svg_icons/WhiteLogo'
import ArrowForward from '../../../atoms/svg_icons/ArrowForward'
export default {
  components: { WhiteLogo, ArrowForward },
  methods: {
    onClickStartButton() {
      location.href = '/'
    }
  }
}
</script>
<style lang="scss" scoped>
.about-cover {
  display: flex;
  align-items: center;
  height: 92vh;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05)),
    url('../../../../../../images/abouts/bg_image/about_image_web_pc.jpg')
      no-repeat center;
  background-size: cover;
  letter-spacing: 0.06em;

  @media all and (max-width: $pc-width - 1) {
    height: 100vw;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.15)),
      url('../../../../../../images/abouts/bg_image/about_image_web_sp.jpg')
        no-repeat center;
    background-size: cover;
  }

  &__logo-space {
    margin-left: auto;
    padding-right: 64px;
    width: 492px;

    @media all and (max-width: $pc-width  - 1) {
      margin-right: auto;
      padding-right: 0;
      width: 273px;
    }
  }

  &__logo {
    display: block;
    width: 243px;
    margin-bottom: 32px;

    @media all and (max-width: $pc-width  - 1) {
      width: 145px;
      margin: 0 auto 16px;
    }
  }

  &__description {
    margin-bottom: 32px;
    display: flex;
    flex-direction: column;
    color: $white;
    font-weight: bold;
    text-align: left;
    font-size: 1.8rem;
    line-height: 2;

    @media all and (max-width: $pc-width  - 1) {
      text-align: center;
      font-size: 1rem;
    }
  }

  &-start-button {
    @extend %hover-common;
    padding: 12px 24px;
    display: flex;
    align-items: center;
    background-color: $white;
    border-radius: 4px;
    cursor: pointer;

    @media all and (max-width: $pc-width  - 1) {
      display: none;
    }

    &__text {
      padding-right: 10px;
      font-weight: bold;
      line-height: 2;
    }

    &__icon {
      width: 24px;
      height: 24px;
    }
  }
}
</style>
